import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { a as EGDSIcon } from '../icon/index-chunk.esm.js';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-button.css';
import { a as analyticsTracker } from '../analytics-tracker/index-chunk.esm.js';
import { v as validatePropType } from '../validate-prop-types/index-chunk.esm.js';

const getClassNameList = classNames.bind(styles);
var EGDSButtonSize;
(function (EGDSButtonSize) {
    EGDSButtonSize["SMALL"] = "small";
    EGDSButtonSize["MEDIUM"] = "medium";
    EGDSButtonSize["LARGE"] = "large";
})(EGDSButtonSize || (EGDSButtonSize = {}));
class EGDSButton extends React.Component {
    static displayName = 'EGDSButton';
    static defaultProps = {
        isFullWidth: false,
        size: EGDSButtonSize.MEDIUM,
    };
    static baseClassName = 'uitk-button';
    render() {
        const { href } = this.props;
        const { analytics, children, className, domRef, isFullWidth, size, tag, ...attributes } = this.props;
        const Tag = tag || (href ? 'a' : 'button');
        const newChildren = [];
        const buttonProps = {
            ...attributes,
        };
        if (Tag === 'button' && !buttonProps.type) {
            buttonProps.type = 'button';
        }
        if (Tag !== 'button' && attributes.disabled) {
            buttonProps['data-disabled'] = 'true';
        }
        // Enable :active css state on touch devices.
        // https://css-tricks.com/snippets/css/remove-gray-highlight-when-tapping-links-in-mobile-safari/
        if (!buttonProps.onTouchStart) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            buttonProps.onTouchStart = () => { };
        }
        const childrenCount = React.Children.toArray(children).length;
        let badge;
        let trailingIcon;
        let leadingIcon;
        let buttonText;
        let a11yText;
        let ariaLabel = attributes['aria-label'];
        React.Children.forEach(children, (child, index) => {
            const existingClassName = child?.props?.className;
            a11yText = child?.props?.['data-a11ytext'] === 'true';
            if (child?.type?.displayName?.match(/(EGDS|Uitk)NotificationBadge/) ||
                child?.type?.displayName?.match(/(EGDS|Uitk)BadgeNotification/)) {
                let badgeLabel = '';
                if (child?.props?.children && typeof child?.props?.children === 'string')
                    badgeLabel = [child?.props?.a11yText, child?.props?.children, child?.props?.count]
                        .filter((text) => !!text)
                        .join();
                if (!ariaLabel && badgeLabel.length)
                    ariaLabel = [buttonText, badgeLabel].filter((text) => !!text).join();
                badge = React.cloneElement(child, {
                    className: 'uitk-button-notification-badge',
                });
            }
            else if (child?.type?.displayName?.match(/(EGDS|Uitk)Icon/) ||
                child?.type?.displayName?.match(/Lodging(EGDS|Uitk)Icon/)) {
                leadingIcon =
                    !leadingIcon && index === 0
                        ? React.cloneElement(child, { className: getClassNameList(existingClassName, 'uitk-icon-leading') })
                        : leadingIcon;
                trailingIcon =
                    !trailingIcon && index !== 0 && index + 1 === childrenCount
                        ? React.cloneElement(child, { className: getClassNameList(existingClassName, 'uitk-icon-trailing') })
                        : trailingIcon;
            }
            else if (typeof child === 'string' || (typeof child?.props?.children === 'string' && !a11yText)) {
                buttonText = buttonText || child;
            }
            else {
                newChildren.push(child);
            }
        });
        if (!buttonProps.onClickCapture && analytics) {
            buttonProps.onClickCapture = analyticsTracker.bind(this, analytics);
        }
        const hasIcon = leadingIcon || trailingIcon;
        const onlyIcon = (hasIcon && childrenCount === 1) || (hasIcon && a11yText && childrenCount === 2);
        const wrapperClassNames = getClassNameList(EGDSButton.baseClassName, {
            [`${EGDSButton.baseClassName}-${size}`]: validatePropType(size, EGDSButtonSize),
        }, {
            [`${EGDSButton.baseClassName}-fullWidth`]: isFullWidth,
            [`${EGDSButton.baseClassName}-has-text`]: buttonText,
            [`${EGDSButton.baseClassName}-only-icon`]: onlyIcon,
            [`${EGDSButton.baseClassName}-as-link`]: href,
        }, className);
        if (!ariaLabel?.length || ariaLabel === buttonText)
            ariaLabel = undefined;
        return (jsxs(Tag, { ...buttonProps, className: wrapperClassNames, ref: domRef, "aria-label": ariaLabel, children: [badge && !(trailingIcon || leadingIcon) && badge, leadingIcon, buttonText, newChildren, trailingIcon] }));
    }
}

var EGDSPagingButtonTheme;
(function (EGDSPagingButtonTheme) {
    EGDSPagingButtonTheme["SOLID"] = "solid-btn";
    EGDSPagingButtonTheme["TRANSPARENT"] = "transparent-btn";
})(EGDSPagingButtonTheme || (EGDSPagingButtonTheme = {}));
class EGDSPagingButton extends React.Component {
    static displayName = 'EGDSPagingButton';
    render() {
        const { icon, iconId, iconTitle, pagingOverlay, children, ...props } = this.props;
        const cssClassNames = classNames(props.className, `${EGDSButton.baseClassName}-paging`, {
            [`${EGDSButton.baseClassName}-paging-overlay`]: pagingOverlay || props.theme === EGDSPagingButtonTheme.TRANSPARENT,
        });
        return (jsxs(EGDSButton, { ...props, className: cssClassNames, children: [icon && jsx(EGDSIcon, { name: icon, id: iconId, title: iconTitle }), children || null] }));
    }
}

export { EGDSButtonSize as E, EGDSButton as a, EGDSPagingButtonTheme as b, EGDSPagingButton as c };
//# sourceMappingURL=index-chunk.esm.js.map
